(function () {
	function initBestSellerProductsSliders() {
		if (typeof Swiper === 'undefined') {
			setTimeout(initBestSellerProductsSliders, 100);
			return;
		}

		var containers = document.querySelectorAll('[data-best-seller-products-slider]');
		if (!containers.length) return;

		containers.forEach(function (container) {
			// Skip if already initialized
			if (container.swiper) {
				return;
			}
			
			// Count total slides
			var totalSlides = container.querySelectorAll('.swiper-slide').length;

			// Prefer controls inside the external navigation wrapper
			var wrapper = container.closest('.best-seller-products-slider__wrapper') || container.parentElement;
			var navRoot = wrapper ? wrapper.querySelector('.best-seller-products-slider__navigation') : null;
			var prevEl = navRoot ? navRoot.querySelector('.swiper-button-prev') : container.querySelector('.swiper-button-prev');
			var nextEl = navRoot ? navRoot.querySelector('.swiper-button-next') : container.querySelector('.swiper-button-next');
			var paginationEl = navRoot ? navRoot.querySelector('.swiper-pagination') : container.querySelector('.swiper-pagination');

			// eslint-disable-next-line no-new
			new Swiper(container, {
				slidesPerView: 2.1,
				spaceBetween: 8,
				watchOverflow: true,
				loop: totalSlides > 2.1 ? true : false,
				keyboard: {
					enabled: true
				},
				a11y: {
					enabled: true
				},
				pagination: paginationEl ? {
					el: paginationEl,
					clickable: true
				} : undefined,
				navigation: prevEl && nextEl ? {
					prevEl: prevEl,
					nextEl: nextEl
				} : undefined,
				breakpoints: {
					768: {
						slidesPerView: 3.1,
						loop: totalSlides > 3.1 ? true : false,
					},
					1025: {
						slidesPerView: 4,
						loop: totalSlides > 4 ? true : false,
					}
				}
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initBestSellerProductsSliders);
	} else {
		initBestSellerProductsSliders();
	}
	
	// Also try after a delay in case the product recommendations haven't loaded yet
	setTimeout(initBestSellerProductsSliders, 1000);
	setTimeout(initBestSellerProductsSliders, 3000);
	
	// Watch for changes in the DOM (for product-recommendations loading)
	var observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutation) {
			if (mutation.type === 'childList') {
				var hasSlider = document.querySelector('[data-best-seller-products-slider]');
				if (hasSlider) {
					initBestSellerProductsSliders();
				}
			}
		});
	});
	
	// Start observing
	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
})();
